import * as React from 'react'

const richSnippet = (data: any) => {
  return (
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  )
}

export default richSnippet
